import { ProductData } from '@commerce-product-webcomponents/sdk';
import {
  ProductSearch,
  Bucket,
  SearchDictionary,
  SearchDictionaryEntry,
  IndexHistoryEntry,
  LowQualitySearchHistoryEntry,
  ContentSearch,
} from '@commerce-search-webcomponents/sdk';

export type SearchState = {
  isLoading: boolean;
  errors: SearchErrors;
  offset: number;
  limit: number;
  facets: Bucket[];
  noResultFilterName: string;
  contentSearchText: string;
  filter: Filter;
  availableQuickFilters: string[];
  quickFilter: string;
  searchCurrentTab: SRP_TABS;
  originallySearchedText: string;
  typeaheadSearchResults: ProductSearch;
  fulltextSearchResults: ProductSearch;
  articlesSearchResults: ContentSearch;
  offersSearchResults: ContentSearch;
  cmsData: CmsData;
  cmsAPISettled: boolean;
  popularProducts: ProductData[];
  searchedProducts: ProductData[];
  searchTrackingType: string;
  overlayOffersResults: ContentSearch;
  overlayArticlesResults: ContentSearch;
  contentSearchLoaders: ContentSearchLoaderType;
};

export type ContentSearchLoaderType = {
  isOverlayOffersLoading: boolean;
  isOverlayArticlesLoading: boolean;
  isOffersLoading: boolean;
  isArticlesLoading: boolean;
};

export type SearchAdminState = {
  synonymGroups: SearchDictionary;
  focusedSynonymGroupEntryId: string | undefined;
  originalSynonymGroupDetail: SearchDictionaryEntry | null;
  searchIndexEntries: IndexHistoryEntry[];
  lowQualityResults: LowQualitySearchHistoryEntry[];
  lowQualityResultEntry: LowQualitySearchHistoryEntry | null;
  focusedLowQualityResultEntryId: string;
};

export type SearchErrors = {
  typeaheadSearchError?: boolean;
  fulltextSearchError?: boolean;
};

export type Filter = {
  sort: string;
  brand: string[];
  price: string;
  category: string;
  solution: string;
};

export type SearchPayloadType = {
  text: string;
  searchMode?: string;
  warehouseId?: string;
};

export type FetchProductsPayloadType = {
  idList: string[];
  fulfillmentType?: string;
  warehouseId?: string;
};

export type PopularProductsPayloadType = {
  fulfillmentType?: string;
  warehouseId?: string;
  isAprEnabled?: boolean;
  fallbackIds?: string[];
  globalProductFallbackIds?: string[];
};

export interface CmsData {
  shop_by_brands?: FeaturedCards;
  shop_by_category?: FeaturedCards;
  products?: Product[];
}
export interface Product {
  product_id: string;
}

export interface FeaturedCards {
  featured_cards?: FeaturedCard[];
}

export interface FeaturedCard {
  display_title?: string;
  items?: FeaturedCardItem[];
}

export interface FeaturedCardItem {
  item_id: string;
  title: string;
  popular: boolean;
}

export type ContentSearchPayloadType = {
  site?: string;
  query?: string;
  page_size?: number;
  locale: string;
  next_page_token?: string;
  sub_category?: string;
  category: string;
  market?: string;
  pageSize?: number;
  reset?: boolean;
};

export enum BucketField {
  SORT = 'sort',
  PRICE = 'price',
  CATEGORY = 'category',
  SOLUTION = 'solution',
  BRAND = 'brand',
  QUICK_FILTERS = 'quickFilters',
}

export enum SRP_TABS {
  ALL = 'all',
  PRODUCTS = 'products',
  OFFERS = 'offers',
  ARTICLES = 'articles',
}

export enum NO_RESULT_FILTERS {
  PRICE = 'price',
}
